import Select from '@domain-group/fe-co-select';
import { useRouter } from 'next/router';
import React, { FC } from 'react';
import * as styles from './version-chooser.styles';

interface VersionChooserProps {
  version: string;
}

interface VersionChooserOption {
  value: string;
  label: string;
  url: string;
}

const VersionChooser: FC<VersionChooserProps> = ({ version }) => {
  const options: VersionChooserOption[] = [
    { value: 'latest', label: 'Latest', url: '/docs/latest' },
    { value: 'v2', label: 'Version 2', url: '/docs/v2' },
    { value: 'v1', label: 'Version 1', url: '/docs/v1' },
  ];

  const router = useRouter();

  const redirectToVersion = (selectedItem: VersionChooserOption) => {
    if (router?.query?.version) {
      router.query.version = selectedItem.value;
      router.push({
        pathname: router.route,
        query: router.query,
      });
    } else {
      // current route has no version, just redirect to base url of version
      router?.push(selectedItem.url);
    }
  };

  // if (version === "latest") version = "v1"

  return (
    <>
      <li css={styles.container}>
        Browse&nbsp;
        <Select
          instanceId="left-nav-version-chooser"
          label="Choose Version"
          labelHidden
          appearance="borderless"
          defaultValue={version}
          options={options}
          nowrap
          onChange={(selectedItem: VersionChooserOption) =>
            redirectToVersion(selectedItem)
          }
        />
      </li>
    </>
  );
};

export default VersionChooser;
